export {default as AuthLayout} from './components/AuthComponent'